import { getProductCouponInfo, } from '@utils/api.js'
import { copyString, } from "@utils/index.js"

// 产品优惠券
if (!customElements.get('v5-app-coupon')) {
  customElements.define('v5-app-coupon', class V5AppCoupon extends HTMLElement {
    constructor() {
      super()

      const {
        variantId, variantPrice, withCodeText, stickyCartWithCodeText, autoApplyText,
        endsInText, countdownLabelText, applyText, termsText, codeCopySuccessText, rulesText
      } = this.dataset

      this.variantId = variantId
      this.variantPrice = variantPrice
      this.timer = null

      this.i18nText = {
        withCodeText,
        stickyCartWithCodeText,
        autoApplyText,
        endsInText,
        countdownLabelText: countdownLabelText.split(','),
        applyText,
        termsText,
        codeCopySuccessText,
        rulesText,
      }
    }
    connectedCallback() {
      this.init()

      // 触发variant变化 - 改变当前变体
      if (document.querySelector('variant-fields')) {
        document.addEventListener('variantChangeEvent', e => {
          const currentVariant = e.detail.variant
          if (currentVariant) {
            this.variantId = currentVariant.id
            this.variantPrice = currentVariant.shopify_price

            setTimeout(() => {
              this.init()
            }, 200)
          }
        })
      }
    }
    disconnectedCallback() {
      this.timer && clearTimeout(this.timer)
    }
    async init() {
      try {
        const { data, } = await getProductCouponInfo({ skuId: this.variantId, })

        if (data) {
          const { api, cr, shopId, } = window.pageInfo
          // 获取服务器时间
          const url = `${api}/osconsumerapi/v1/com/get-server-time?shopify_shop_id=${shopId || ''}&cr=${cr || ''}`
          const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            headers: { "Content-Type": "application/json", },
          });
          const { data: { datetime }, } = await response.json();
          const serverTime = new Date(datetime).getTime()

          const { code, couponAmountShowType, showCountDown, value, valueType, startDate, endDate, discountScope, countDownLimitDays, usageDesc } = data;

          // 如果服务端时间，大于 结束时间，则直接 return
          if (serverTime < new Date(startDate).getTime() || serverTime >= new Date(endDate).getTime()) {
            // 清空DOM
            this.clearDOM()
            return
          }

          // 提取时间计算逻辑为独立函数
          const calculateStartTime = (startDate, endDate, countDownLimitDays = 0) => {
            if (countDownLimitDays == 0) {
              return new Date(startDate).getTime();
            }

            const limitTime = countDownLimitDays * 86400000; // 24*60*60*1000
            const limitStartTime = new Date(endDate).getTime() - limitTime;
            return Math.max(limitStartTime, new Date(startDate).getTime());
          };

          if (showCountDown === 1 && endDate) {
            /**
             * 1、显示倒计时
             * 2、新增逻辑, 到期多少天显示 逻辑
             * 3、倒计时开始：
             *      1、当countDownLimitDays为null时 取startDate
             *      1、当startDate大于endDate - countDownLimitDays 取startDate
             *      2、当startDate小于endDate - countDownLimitDays 取 endDate - countDownLimitDays
             */
            const startTime = calculateStartTime(startDate, endDate, countDownLimitDays);

            // 统一DOM显示控制逻辑
            const showDOM = (content) => {
              this.innerHTML = content;
              this.parentElement.style.display = 'block';
              this.parentElement.setAttribute('data-show', true);
            };

            if (startTime <= serverTime) {
              showDOM(this.renderDOM(1, code, couponAmountShowType, value, valueType, discountScope));

              // 初始化倒计时数据
              this.countdownDOM = this.querySelector('[data-count-down]');
              if (this.countdownDOM) {
                this.timer && clearTimeout(this.timer)
                this.initCountdownData({
                  serverTime,
                  startTime: new Date(startDate).getTime(),
                  endTime: new Date(endDate).getTime()
                })
              }
            } else {
              showDOM(this.renderDOM(0, code, couponAmountShowType, value, valueType, discountScope));
            }
          } else {
            // 非倒计时模式直接显示默认内容
            this.innerHTML = this.renderDOM(0, code, couponAmountShowType, value, valueType, discountScope);
            this.parentElement.style.display = 'block';
            this.parentElement.setAttribute('data-show', true);
          }

          // 注册 copy and use 按钮事件
          if (this.querySelector('[data-copy-and-use]')) {
            this.querySelector('[data-copy-and-use]').onclick = () => {
              copyString(code, () => {
                // 提示 copy 成功
                pushSuccessMessage(this.i18nText.codeCopySuccessText)

                // 数据埋码
                gaPushDataLayer('5.0_products_details_page_user_clicks', {
                  product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
                  module: "Product Discount", //固定名称Product Discount
                  position: this.querySelector('h4')?.querySelector('span:first-of-type')?.textContent?.trim(), // 识别优惠券标题
                  button_name: 'CodeCopy', // 固定名称CodeCopy
                })
              })
            }
          }

          // 注册 tips 按钮事件
          if (this.querySelector('[data-coupon-rules-btn]')) {
            this.querySelector('[data-coupon-rules-btn]').onclick = () => {
              const popupHtml = `
                <div class="font-semibold text-[#242F20] mb-2 lg:mb-4 text-xl lg:text-3xl">
                  ${this.i18nText.rulesText}
                </div>
                <div class="font-normal text-[#242F20]/65 text-sm lg:text-lg">
                  ${usageDesc}
                </div>
              `

              const jdsDialog = document.querySelector(`jds-dialog#v5-app-coupon-rules-popup-${this.variantId}`);
              if (!jdsDialog) {
                const dialog = document.createElement('jds-dialog');
                dialog.id = `v5-app-coupon-rules-popup-${this.variantId}`
                dialog.style = '--jds-dialog-index:999999999'
                dialog.innerHTML = `<div class="jds-rte">${popupHtml}</div>`;
                document.body.appendChild(dialog);
              }

              // 打开弹窗
              document.querySelector(`jds-dialog#v5-app-coupon-rules-popup-${this.variantId}`)?.setAttribute('open', true);

              // 数据埋码
              gaPushDataLayer('5.0_products_details_page_user_clicks', {
                product_spu_name: this.getAttribute('data-product-title'), // 识别页面产品spu标题名称text
                module: "Product Discount", //固定名称Product Discount
                position: this.querySelector('h4')?.querySelector('span:first-of-type')?.textContent?.trim(), // 识别优惠券标题
                button_name: this.i18nText?.termsText?.trim(), // 识别按钮文本
              })
            }
          }
        } else {
          this.clearDOM()
        }
      } catch (err) {
        this.clearDOM()
      }
    }
    // 清空DOM
    clearDOM() {
      this.innerHTML = ''
      this.parentElement.style.display = 'none'
      this.parentElement.setAttribute('data-show', false)

      // 更新 吸底购物车 处内容
      if (document.querySelector('jky-v5-sticky-cart')) {
        document.querySelector('jky-v5-sticky-cart').querySelector('[data-sticky-copy-wrap]').style.display = 'none'
      }
    }
    // 处理金额格式化，如果小数点后两位都是0，则去掉小数部分
    formatCouponMoney(money, moneyFormat) {
      const formattedMoney = formatMoney(money, moneyFormat)
      // 检查是否以.00结尾（考虑不同货币符号的位置）
      return formattedMoney.replace(/(\.00)(?=[^0-9]*$)/, '')
    }
    // 计算折扣金额或百分比
    renderDiscountValue(couponAmountShowType, value, valueType) {
      const moneyFormat = window?.pageInfo?.currency?.money_format
      return couponAmountShowType === 0
        ? valueType === 0 ? this.formatCouponMoney(value * 100, moneyFormat) : `${value}%`
        : valueType === 0 ? this.formatCouponMoney(value * 100, moneyFormat) : this.formatCouponMoney(value * this.variantPrice / 100, moneyFormat)
    }
    renderDOM(showCountDown, code, couponAmountShowType, value, valueType, discountScope) {
      // 计算折扣金额或百分比
      const couponValue = this.renderDiscountValue(couponAmountShowType, value, valueType)

      // 非自动折扣，更新 吸底购物车 处内容
      if (document.querySelector('jky-v5-sticky-cart') && discountScope === 1) {
        const copyWrap = document.querySelector('jky-v5-sticky-cart').querySelector('[data-sticky-copy-wrap]')
        copyWrap.querySelector('[data-sticky-copy-discount-title]').textContent = this.i18nText.stickyCartWithCodeText.replace('{price}', couponValue)
        copyWrap.querySelector('[data-sticky-copy-discount-code]').querySelector('span').textContent = code
        copyWrap.style.display = 'flex'

        // 注册 copy and use 按钮事件
        copyWrap.querySelector('[data-sticky-copy-discount-code]').onclick = () => {
          copyString(code, () => {
            // 提示 copy 成功
            pushSuccessMessage(this.i18nText.codeCopySuccessText)

            // 数据埋码
            gaPushDataLayer('5.0_products_details_page_user_clicks', {
              product_spu_name: this.getAttribute('data-product-title'), //识别页面产品spu标题名称text
              module: "Product Discount", //固定名称Product Discount
              position: "Bottom Cart", //固定名称BottomCart
              button_name: "CodeCopy", // 固定按钮名称CodeCopy
              content: code, //识别优惠券的券码text
            })
          })
        }
      } else {
        // 隐藏
        const stickyCart = document.querySelector('jky-v5-sticky-cart')
        stickyCart && (stickyCart.querySelector('[data-sticky-copy-wrap]').style.display = 'none')
      }

      return `
        ${discountScope === 1
          ? `<h4 class="flex flex-wrap gap-x-4 gap-y-1">
              <span class="text-primary font-semibold text-base lg:text-2xl">${this.i18nText.withCodeText.replace('{price}', couponValue)}</span>
              <button class="appearance-none bg-transparent flex items-center gap-x-2 lg:gap-x-4" data-copy-and-use>
                <span class="font-semibold text-black bg-[#E8E8E5] text-lg lg:text-2xl px-2">${code}</span>
                <svg class="w-5 h-5 lg:w-6 lg:h-6" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <rect width="30" height="30" fill="url(#pattern0_4_79)"/>
                  <defs>
                    <pattern id="pattern0_4_79" patternContentUnits="objectBoundingBox" width="1" height="1">
                      <use xlink:href="#image0_4_79" transform="scale(0.005)"/>
                    </pattern>
                    <image id="image0_4_79" width="200" height="200" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                  </defs>
                </svg>
              </button>
            </h4>`
          : `<h4 class="flex flex-wrap gap-x-4 gap-y-1">
              <span class="text-primary font-semibold text-base lg:text-2xl">${this.i18nText.autoApplyText.replace('{price}', couponValue)}</span>
            </h4>`
        }
        ${showCountDown === 1
          ? `<div class="w-full flex flex-wrap items-center gap-x-1" data-count-down>
              <span class="text-black/65 text-sm lg:text-base mr-1 lg:mr-3">${this.i18nText.endsInText}</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[0]?.trim() || ''}</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[1]?.trim() || ''}</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[2]?.trim() || ''}</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg -mt-0.5">:</span>
              <span class="text-[#242F20] font-semibold text-sm lg:text-lg">00 ${this.i18nText.countdownLabelText[3]?.trim() || ''}</span>
            </div>`
          : ''
        }
        <div class="flex flex-col gay-y-1 lg:gap-y-2">
          ${discountScope === 1 && this.i18nText.applyText
            ? `<p class="w-full text-left text-[#242F20] text-sm lg:text-base">${this.i18nText.applyText}</p>`
            : ''
          }
          ${this.i18nText.termsText
            ? `<button data-coupon-rules-btn class="w-fit text-left appearance-none bg-transparent text-black/65 active:text-primary visited:text-[#242F20] text-sm lg:text-base underline underline-offset-4">${this.i18nText.termsText}</button>`
            : ''
          }
        </div>
      `
    }
    // 倒计时初始化
    async initCountdownData({ serverTime, startTime, endTime, }) {
      if (serverTime >= startTime) {
        this.tick(endTime, serverTime)
      } else {
        // 移除DOM
        this.parentElement.removeChild(this)
      }
    }
    // 倒计时 span
    renderCountdownSpan(days, hours, minutes, seconds) {
      const style = 'text-[#242F20] font-semibold text-sm lg:text-lg'

      return `
        <span class="text-black/65 text-sm lg:text-base mr-1 lg:mr-3">${this.i18nText.endsInText}</span>
        <span class="${style}">${days || ''} ${this.i18nText.countdownLabelText[0]?.trim() || ''}</span>
        <span class="${style} -mt-0.5">:</span>
        <span class="${style}">${hours || ''} ${this.i18nText.countdownLabelText[1]?.trim() || ''}</span>
        <span class="${style} -mt-0.5">:</span>
        <span class="${style}">${minutes || ''} ${this.i18nText.countdownLabelText[2]?.trim() || ''}</span>
        <span class="${style} -mt-0.5">:</span>
        <span class="${style}">${seconds || ''} ${this.i18nText.countdownLabelText[3]?.trim() || ''}</span>
      `
    }
    tick(target, current) {
      const leftTime = (target - current) / 1000
      let days, hours, minutes, seconds

      if (leftTime <= 0) {
        this.timer && clearTimeout(this.timer)

        // 移除 DOM
        this.parentElement.removeChild(this)
      } else {
        days = String(parseInt(leftTime / 60 / 60 / 24)).padStart(2, '0')
        hours = String(parseInt(leftTime / 60 / 60 % 24)).padStart(2, '0')
        minutes = String(parseInt(leftTime / 60 % 60)).padStart(2, '0')
        seconds = String(parseInt(leftTime % 60)).padStart(2, '0')

        this.countdownDOM.innerHTML = this.renderCountdownSpan(days, hours, minutes, seconds)

        this.timer = setTimeout(() => this.tick(target, current + 1000), 1000)
      }
    }
  })
}
